import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, filter, takeUntil } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-custom-cost-popup',
  templateUrl: './custom-cost-popup.component.html',
  styleUrls: ['./custom-cost-popup.component.scss']
})
export class CustomCostPopupComponent implements OnInit,OnDestroy {
  customForm = new FormGroup({
    dateTo: new FormControl(""),
    dateFrom: new FormControl("",Validators.required),
    isPeriod: new FormControl(true),
    qty: new FormControl(""),
    price: new FormControl("",Validators.required)
})
  costData: any;
  show: boolean =true;
  spin: boolean=false;
  private destroy$ = new Subject<void>();
  
  constructor( @Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<CustomCostPopupComponent>,
  private snackBar: MatSnackBar,
  private planyardService: PlanyardService,
  private dialog:MatDialog,
  private inventoryService: InventoryService
  ) { }

  ngOnInit(): void {
    if(!this.data.isPeroid){
      this.show = false;
      this.customForm.get("qty").setValidators(Validators.required);
      this.customForm.get("qty").updateValueAndValidity();
      this.customForm.get("dateFrom").clearValidators();
      this.customForm.get('dateFrom').updateValueAndValidity();
      this.customForm.controls["isPeriod"].setValue(false);
      this.customForm.controls["isPeriod"].disable();
     }
     else{
      this.customForm.controls["isPeriod"].setValue(true);
      this.customForm.controls["isPeriod"].disable();
     }
    if(this.data.isPeroid==undefined){
      this.customForm.controls["isPeriod"].enable();
      this.customForm.controls["isPeriod"].setValue(true);
      this.show=true;
      this.customForm.get("dateFrom").setValidators(Validators.required);
      this.customForm.get("dateFrom").updateValueAndValidity();
      this.customForm.get("qty").clearValidators();
      this.customForm.get('qty').updateValueAndValidity();
    }
    this.customForm.controls["dateTo"].disable();
    this.costData = this.data.data;
    if(this.costData?.isPeriod){
      this.show=false;
    }
    this.customForm.controls["isPeriod"].valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (!res) {
        this.show = false;
        this.customForm.get("qty").setValidators(Validators.required);
        this.customForm.get("qty").updateValueAndValidity();
        this.customForm.get("dateFrom").clearValidators();
        this.customForm.get('dateFrom').updateValueAndValidity();
      } else {
        this.show = true;
        this.customForm.get("dateFrom").setValidators(Validators.required);
        this.customForm.get("dateFrom").updateValueAndValidity();
        this.customForm.get("qty").clearValidators();
        this.customForm.get('qty').updateValueAndValidity();
      }
    })
    this.customForm.controls["dateFrom"].valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if(res){
        this.customForm.controls["dateTo"].enable();
      }
    })
    this.customForm.patchValue(this.costData);
    if(this.customForm.value.dateFrom && (!this.customForm.value.isPeriod || this.customForm.value.isPeriod  )){
      this.customForm.controls["isPeriod"].disable();
    }
  }
  
  close(){
    this.dialogRef.close();
  }

  action(e?) {
    if(e === 'Save'){
      this.saveCustomCost();
    }else {
      this.close()
    }
  }

  saveCustomCost() {
    let dateFrom:any;
    let dateTo:any;
    dateFrom=new Date(this.customForm?.value.dateFrom);
    dateTo= new Date(this.customForm?.value.dateTo);
     dateFrom= new Date(dateFrom.setHours(0,0,0,0) -(dateFrom.getTimezoneOffset() * 60000)).toISOString();
     if(this.customForm?.value.dateTo){
      dateTo= new Date(dateTo.setHours(23,59,59,59)- (dateTo.getTimezoneOffset() * 60000)).toISOString();
    }
    this.spin=true;
    let payload;
    if(this.show) {
       payload= {
        dateFrom: dateFrom,
        dateTo: dateTo,
        price: this.customForm.value.price,
        accountSkuId: this.data.accountSkuId,
        isPeriod: this.costData ? this.costData.isPeriod : this.customForm.get('isPeriod').value
      }
    }
    else{
       payload = {
        dateFrom: dateFrom,
        price: this.customForm.value.price,
        accountSkuId: this.data.accountSkuId,
        isPeriod: this.costData ? this.costData.isPeriod : this.customForm.get('isPeriod').value,
        qty: this.customForm.value.qty
      }
    }
    if (this.costData?.customCostId) {
      payload.customCostId = this.costData.customCostId;
    }
    this.planyardService.saveCost(payload).pipe(takeUntil(this.destroy$)).subscribe({
     next: (res) => {
      let snackBarRef = this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        horizontalPosition: "center",
        data: {
          title: 'Cost Detail has been updated successfully, please recalcute for get updated data',
          action: "Recalculate",
          type: "success",
        },
      });
      snackBarRef.onAction().pipe(takeUntil(this.destroy$)).subscribe(() => {
       this.recalculateCostDetail();
      })
      this.spin= false;
      this.dialogRef.close("Confirm");
    },
    error: (error) => {
      this.spin= false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: error.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        })
     }
    });
  }

  recalculateCostDetail(){
    this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Recalculate Cost Detail",
        message: `Are you sure you want to recalc as it may take a few minutes?`
      },
    })
    .afterClosed()
    .pipe(filter((e) => e === "Confirm"))
    .subscribe((e) => {
      this.inventoryService.recalOrdersYearInsertBm().pipe(takeUntil(this.destroy$)).subscribe({
        next: (e: number) => {
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title:err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
      });     
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
